import {ToastBar, Toaster} from 'react-hot-toast'

export const Toast = () => (
  <Toaster
    position="top-center"
    gutter={8}
    toastOptions={{
      duration: 3000,
      style: {
        // background: '#004df5',
        // color: '#fff',
        borderRadius: '8px',
      },

      success: {
        style: {
          // background: '#76d69f',
          // color: '#fff',
          borderRadius: '8px',
        },
      },

      error: {
        duration: 8000,
        style: {
          // background: '#ff8585',
          // color: '#071c44',
          borderRadius: '8px',
        },
      },
    }}
    containerStyle={{
      zIndex: 9999999,
    }}
  >
    {t => (
      <ToastBar
        toast={t}
        style={{
          ...t.style,
          zIndex: 9999999,
          // animation: t.visible ? 'custom-enter 1s ease' : 'custom-exit 1s ease forwards',
        }}
      />
    )}
  </Toaster>
)
